module.exports = __webpack_public_path__ + "img/defaultAvatar.1f7bc1f8.png";